import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ClosedDropdownIcon = ({ className }) => (
  React.createElement(SvgIcon, { className: className, fill: "none", xmlns: "http://www.w3.org/2000/svg",}
    , React.createElement('path', { d: "M7.5 8L6 9.5L12.0703 15.5703L18.1406 9.5L16.6406 8L12.0703 12.5703L7.5 8Z"       ,} )
  )
);

export default ClosedDropdownIcon;
